module.exports = "<div class=\"tab-content\">\r\n  <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/layouts/tabs/spk-tab-panes/spk-tab-panes.component.html
// module id = ./src/app/components/framework/spk/layouts/tabs/spk-tab-panes/spk-tab-panes.component.html
// module chunks = main